/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Swap_Later_ToastInputs */

const en_us2_swap_later_toast = /** @type {(inputs: Swap_Later_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} moved to the end of the workout`)
};

const pt_br2_swap_later_toast = /** @type {(inputs: Swap_Later_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} foi para o fim do treino`)
};

const es_419_swap_later_toast = /** @type {(inputs: Swap_Later_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} pasó al final del entrenamiento`)
};

const pt_pt2_swap_later_toast = /** @type {(inputs: Swap_Later_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} passou para o fim do treino`)
};

const fr_fr2_swap_later_toast = /** @type {(inputs: Swap_Later_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} passe à la fin de la séance`)
};

const de_de2_swap_later_toast = /** @type {(inputs: Swap_Later_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ans Ende des Trainings verschoben`)
};

const it_it2_swap_later_toast = /** @type {(inputs: Swap_Later_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} spostato alla fine dell'allenamento`)
};

/**
* | output |
* | --- |
* | "{name} moved to the end of the workout" |
*
* @param {Swap_Later_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_later_toast = /** @type {((inputs: Swap_Later_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Later_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_later_toast(inputs)
	if (locale === "es-419") return es_419_swap_later_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_later_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_later_toast(inputs)
	if (locale === "de-DE") return de_de2_swap_later_toast(inputs)
	if (locale === "it-IT") return it_it2_swap_later_toast(inputs)
	return en_us2_swap_later_toast(inputs)
});
export { swap_later_toast as "swap.later_toast" }